<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style>
html {
  overflow-x: hidden; /* prevent horizontal scroll on html, not body — avoids body becoming a scroll container */
}

body {
  min-height: 100vh;
  overscroll-behavior-x: none;
  font-family: Inter, system-ui, -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
}
</style>
